import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DatatableComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';

import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { ImpersonationModule } from '@amfam/shared/utility/impersonation';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { BillAccountPaymentsScheduledBundleComponent } from './components/bill-account-payments-scheduled-bundle/bill-account-payments-scheduled-bundle.component';
import { BillAccountScheduledPaymentDeleteComponent } from './components/bill-account-payments-scheduled-delete/bill-account-payments-scheduled-delete.component';
import { BillAccountPaymentsScheduledModalComponent } from './components/bill-account-payments-scheduled-modal/bill-account-payments-scheduled-modal.component';
import { ExpiredPaymentAccountWarningComponent } from './components/expired-payment-account-warning/expired-payment-account-warning.component';
import { PaymentRadioSelectionComponent } from './components/payment-radio-selection/payment-radio-selection.component';
import { PaymentTermsComponent } from './components/payment-terms';
import { PaymentsScheduledComponent } from './containers/bill-account-payments-scheduled/bill-account-payments-scheduled.component';

@NgModule({
  imports: [
    BrandDirectivesModule,
    CommonModule,
    UiKitModule,
    SharedServicesModule,
    RouterModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    ImpersonationModule,
    DsRouterLinkModule
  ],
  declarations: [
    PaymentsScheduledComponent,
    BillAccountScheduledPaymentDeleteComponent,
    BillAccountPaymentsScheduledBundleComponent,
    ExpiredPaymentAccountWarningComponent,
    PaymentRadioSelectionComponent,
    PaymentTermsComponent,
    BillAccountPaymentsScheduledModalComponent
  ],
  exports: [
    PaymentsScheduledComponent,
    BillAccountScheduledPaymentDeleteComponent,
    BillAccountPaymentsScheduledBundleComponent,
    ExpiredPaymentAccountWarningComponent
  ],
  providers: [DatatableComponent]
})
export class BillingSchedulepaymentFeatureModule {}
